import Vue from "vue";
import { Component } from "vue-property-decorator";
import $ from "jquery";
import moment from "moment";
import { ParametresInstance } from "../../Controls/Parameters";
import { SocieteDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { EventBus } from "../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalAlerte/modalAlerte";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalCloturePaie extends Vue {
    public libelleSocieteCourante?: string = "";
    public dateDebutTraitement?: Date = undefined;
    public dateFinTraitement?: Date = undefined;

    public dateVirement?: string = undefined;
    public controlesFaits = false;
    public envoieParMail = false;
    public estClotureEnCours = false;

    public societeCourante?: SocieteDto = undefined;
    public paieEnable = false;

    public mounted(): void {
        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
        });
        this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
    }

    public init(): void {
        const societe = ParametresInstance.societeCourante;
        if (societe != undefined && societe.PeriodeActive != undefined) {
            this.initSociete();
        }
        EventBus.$on(EventConstants.SOCIETE_CHANGED, (e) => {
            const societe = e as SocieteDto;
            if (societe != undefined && societe.PeriodeActive != undefined) {
                this.initSociete();
            }
        });

        $("#modalCloturePaie").modal("show");
    }

    public initSociete(): void {
        this.societeCourante = ParametresInstance.societeCourante;
        this.controlesFaits = false;
        this.libelleSocieteCourante = "";
        this.dateDebutTraitement = undefined;
        this.dateFinTraitement = undefined;
        this.dateVirement = undefined;

        if (this.societeCourante != undefined) {
            this.libelleSocieteCourante = this.societeCourante.Libelle;
        }

        if (this.societeCourante != undefined) {
            this.dateDebutTraitement = this.societeCourante.PeriodeActive;
        }

        if (this.dateDebutTraitement != undefined) {
            this.dateFinTraitement = moment.utc(this.dateDebutTraitement).add("month", 1).add("day", -1).toDate();
        }

        if (this.dateFinTraitement != undefined) {
            this.dateVirement = moment.utc(this.dateFinTraitement).format("YYYY-MM-DD");
        }

        const isPST = ParametresInstance.isPst;
        if (isPST && this.societeCourante != undefined && this.societeCourante.CodeServiceSST == "MT01") {
            NotificationServiceInstance.SendWarning("Votre Service SST présent dans PARAMETRAGE > Société est incorrect.");
        }
    }

    public getDateDebut() {
        return moment.utc(this.dateDebutTraitement).format("DD/MM/YYYY");
    }

    public getDateFin() {
        return moment.utc(this.dateFinTraitement).format("DD/MM/YYYY");
    }

    public enregistrer(): void {
        if (this.societeCourante == undefined) {
            return;
        }

        if (this.paieEnable) {
            if (this.dateVirement == undefined || this.dateVirement == "") {
                const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                    message: "Merci de saisir une date de règlement."
                });
                EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);

                return;
            }
        }
        this.estClotureEnCours = true;

        ServicesFactoryInstance.CalculPaieService.cloturerExercice({
            IdSociete: this.societeCourante.Id,
            EnvoieBulletinsParMail: this.envoieParMail,
            DateVirement: moment.utc(this.dateVirement).toDate()
        }, () => {
            this.estClotureEnCours = false;
            $("#modalCloturePaie").modal("hide");
            window.location.reload();
        }, () => {
            this.estClotureEnCours = false;
        });
    }

    public annuler(): void {
        $("#modalCloturePaie").modal("hide");
    }
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalCloturePaie/modalCloturePaie.ts